




































































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import _ from 'lodash'
import Apis from '@/Apis/_'
import EventBus from '@/plugins/EventBus'
import ConfigUsuarioStore, { TipoBuscaPessoa, TAMANHO_MINIMO_BUSCA_PESSOA, TAMANHO_CPF } from '@/components/Configuracoes/store/ConfigUsuarioStore'
import { getSnackbarMessage, maskCPFCNPJ } from '@/utils/common'
import ResponseApi from '@/types/interfaces/FactoryResponse'
import { AcessoEspelhado, PessoaBuscaEspelho, UsuarioAgendamento } from '@/types/interfaces/Usuario'
import { Hospital } from '@/types/interfaces/Solicitacao'

interface GrupoChips {
  titulo: string,
  itens: string[],
}

@Component
export default class PainelUsuarioEspelho extends Vue {
  @Prop({ default: () => [] }) hospitais: Pick<Hospital, 'id' | 'nome'>[]

  textoBusca: string | null = ''
  pessoasEncontradas: PessoaBuscaEspelho[] = []
  pessoaSelecionadaId: string = ''
  pessoaEspelho: PessoaBuscaEspelho | null = null
  acessoEspelho: AcessoEspelhado | null = null
  acessoAntesDoEspelhamento: AcessoEspelhado | null = null

  copiarOperadoras: boolean = true
  copiarHospitais: boolean = true
  copiarPermissoes: boolean = true

  loadingBuscaPessoas: boolean = false
  loadingUsuarioEspelho: boolean = false

  get configUsuarioStore() {
    return getModule(ConfigUsuarioStore, this.$store)
  }

  get hasUsuarioEspelho() {
    return !!this.acessoEspelho
  }

  get isEspelhado() {
    return !!this.acessoAntesDoEspelhamento
  }

  get situacaoPessoaSelecionada() {
    if (this.pessoaEspelho && this.pessoaEspelho.dataExclusao) {
      return 'Excluído'
    }

    return 'Ativo'
  }

  get defaultPageEspelho() {
    if (!this.acessoEspelho || !this.acessoEspelho.dadosUsuarioSeguranca.defaultPage) {
      return '-'
    }

    return this.acessoEspelho.dadosUsuarioSeguranca.defaultPage.view
  }

  get gruposChips(): GrupoChips[] {
    if (!this.acessoEspelho) {
      return []
    }

    const seguranca = this.acessoEspelho.dadosUsuarioSeguranca

    return [
      { titulo: 'Hospitais', itens: this.getNomesHospitais(this.acessoEspelho.hospitais) },
      { titulo: 'Operadoras', itens: this.getNomesOperadoras(this.acessoEspelho.idsOperadoras) },
      { titulo: 'Pages Authorized', itens: seguranca.legacyPageAuthorized },
      { titulo: 'Roles', itens: seguranca.legacyRoles },
      { titulo: 'Permissões', itens: seguranca.permissoesExtras },
    ]
  }

  @Emit('close')
  close() {}

  @Watch('textoBusca')
  onTextoBuscaChange(texto: string | null) {
    if (!texto || (this.pessoaEspelho && texto === this.pessoaEspelho.nome)) {
      return
    }

    this.searchPessoasDebounce(texto)
  }

  searchPessoasDebounce = _.debounce((texto: string) => this.searchPessoas(texto), 600)

  /** O backend aceita um único filtro (nome, email ou cpf) e rejeita termo curto com 400 (FXCS-6701). */
  getFiltroBusca(texto: string): Partial<Record<TipoBuscaPessoa, string>> | null {
    const termo = texto.trim()
    const digitos = termo.replace(/\D/g, '')

    if (/^[\d.\-\s]+$/.test(termo)) {
      return digitos.length === TAMANHO_CPF ? { cpf: digitos } : null
    }

    if (termo.length < TAMANHO_MINIMO_BUSCA_PESSOA) {
      return null
    }

    if (termo.includes('@')) {
      return { email: termo }
    }

    return { nome: termo }
  }

  async searchPessoas(texto: string) {
    const filtro = this.getFiltroBusca(texto)

    if (!filtro) {
      this.pessoasEncontradas = []
      return
    }

    this.loadingBuscaPessoas = true

    const response: ResponseApi<{ pessoas: PessoaBuscaEspelho[] }> = await Apis.Cadastro.CadastroApi.getPessoalAll({
      page: 1,
      rowsPerPage: 10,
      ...filtro,
    })

    this.loadingBuscaPessoas = false

    if (!response.success || !response.data) {
      EventBus.$emit('setSnackbar', getSnackbarMessage(response.message || 'Ocorreu um erro ao buscar os usuários.', 'error'))
      return
    }

    this.pessoasEncontradas = response.data.pessoas || []
  }

  async loadUsuarioEspelho(id: string) {
    this.acessoEspelho = null
    this.pessoaEspelho = this.pessoasEncontradas.find(pessoa => pessoa.id === id) || null

    if (!id) {
      return
    }

    this.loadingUsuarioEspelho = true

    const response: ResponseApi<UsuarioAgendamento> = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getUsuarioAgendamentoById(id)

    this.loadingUsuarioEspelho = false

    if (!response.success || !response.data) {
      EventBus.$emit('setSnackbar', getSnackbarMessage(response.message || 'Ocorreu um erro ao carregar o usuário espelho.', 'error'))
      return
    }

    this.acessoEspelho = this.mapAcesso(response.data)
  }

  mapAcesso(usuario: UsuarioAgendamento): AcessoEspelhado {
    const seguranca = usuario.dadosUsuarioSeguranca

    return {
      hospitais: (usuario.hospitais || []).map(id => _.toUpper(id)),
      idsOperadoras: (usuario.dadosUsuarioOperadora && usuario.dadosUsuarioOperadora.idsOperadoras) || [],
      dadosUsuarioSeguranca: {
        login: seguranca.login,
        legacyProfile: seguranca.legacyProfile,
        defaultPage: seguranca.defaultPage,
        legacyPageAuthorized: seguranca.legacyPageAuthorized || [],
        legacyRoles: seguranca.legacyRoles || [],
        permissoesExtras: seguranca.permissoesExtras || [],
      },
    }
  }

  getAcessoAtual(): AcessoEspelhado {
    const usuario = this.configUsuarioStore.usuarioAgendamento

    return _.cloneDeep({
      hospitais: usuario.hospitais || [],
      idsOperadoras: usuario.dadosUsuarioOperadora.idsOperadoras || [],
      dadosUsuarioSeguranca: usuario.dadosUsuarioSeguranca,
    })
  }

  espelhar() {
    const espelho = this.acessoEspelho

    if (!espelho) {
      return
    }

    this.acessoAntesDoEspelhamento = this.getAcessoAtual()

    const usuario = this.configUsuarioStore.usuarioAgendamento

    if (this.copiarHospitais) {
      usuario.hospitais = [...espelho.hospitais]
    }

    if (this.copiarOperadoras) {
      usuario.dadosUsuarioOperadora.idsOperadoras = [...espelho.idsOperadoras]
    }

    if (this.copiarPermissoes) {
      this.replacePermissoes(espelho)
    }

    this.emitEspelhado()
    EventBus.$emit('setSnackbar', getSnackbarMessage('Os acessos foram substituídos pelos do usuário espelho. Nada é gravado até clicar em Salvar.', 'warning'))
  }

  replacePermissoes(espelho: AcessoEspelhado) {
    const seguranca = this.configUsuarioStore.usuarioAgendamento.dadosUsuarioSeguranca
    const segurancaEspelho = espelho.dadosUsuarioSeguranca

    seguranca.legacyProfile = segurancaEspelho.legacyProfile
    seguranca.defaultPage = _.cloneDeep(segurancaEspelho.defaultPage)
    seguranca.legacyPageAuthorized = [...segurancaEspelho.legacyPageAuthorized]
    seguranca.legacyRoles = [...segurancaEspelho.legacyRoles]
    seguranca.permissoesExtras = [...segurancaEspelho.permissoesExtras]
  }

  @Emit('espelhado')
  emitEspelhado(): string[] {
    const grupos = [
      { label: 'hospitais', isCopiado: this.copiarHospitais },
      { label: 'operadoras', isCopiado: this.copiarOperadoras },
      { label: 'permissões', isCopiado: this.copiarPermissoes },
    ]

    return grupos.filter(grupo => grupo.isCopiado).map(grupo => grupo.label)
  }

  @Emit('limpo')
  emitLimpo() {}

  limparEspelhamento() {
    const usuario = this.configUsuarioStore.usuarioAgendamento
    const anterior = this.acessoAntesDoEspelhamento
    const seguranca = usuario.dadosUsuarioSeguranca

    if (!anterior) {
      return
    }

    usuario.hospitais = anterior.hospitais
    usuario.dadosUsuarioOperadora.idsOperadoras = anterior.idsOperadoras
    seguranca.legacyProfile = anterior.dadosUsuarioSeguranca.legacyProfile
    seguranca.defaultPage = anterior.dadosUsuarioSeguranca.defaultPage
    seguranca.legacyPageAuthorized = anterior.dadosUsuarioSeguranca.legacyPageAuthorized
    seguranca.legacyRoles = anterior.dadosUsuarioSeguranca.legacyRoles
    seguranca.permissoesExtras = anterior.dadosUsuarioSeguranca.permissoesExtras

    this.acessoAntesDoEspelhamento = null
    this.emitLimpo()
  }

  getNomesHospitais(ids: string[]) {
    return ids.map((id) => {
      const hospital = this.hospitais.find(item => _.toUpper(item.id) === id)

      return hospital ? hospital.nome : id
    })
  }

  getNomesOperadoras(ids: string[]) {
    return ids.map((id) => {
      const operadora = this.configUsuarioStore.operadoras.find(item => item.id === id)

      return operadora ? operadora.nome : id
    })
  }

  formatCpf(cpf: string) {
    return maskCPFCNPJ(cpf)
  }
}
